import { AppAction, RootState } from '../types';

type Reducer<S> = (state: S, action: AppAction) => S;

type ReducersMapObject<S> = {
  [K in keyof S]: Reducer<S[K]>;
};

export function combineReducers<S extends RootState>(
  reducers: ReducersMapObject<S>
): Reducer<S> {
  return (state: S, action: AppAction): S => {
    const newState = {} as S;
    const keys = Object.keys(reducers) as Array<keyof S>;

    keys.forEach((key) => {
      const result = reducers[key](state[key], action);
      newState[key] = result ?? state[key];
    });

    return newState;
  };
}
